import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { PagerList, GlobalInfo, FPMessage, Severities, PageKey, RoleAccess } from '../shared.model';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { BaseComponent } from '../base.component';
import { SharedService, Status, RowsPerOptions } from '../shared.service';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Message, ConfirmationService, SelectItem, MultiSelectModule } from 'primeng/primeng';
import { LoaderService } from '../loader.service';
import { CapitalizeFirstPipe } from '../pipes/custom-pipes.pipe';
import { ValidationService } from '../.././technician/technician-jobs/technician-common-validation';
import { TechnicianJobService } from '../.././technician/technician-jobs/technician-jobs.service';
import { ClosePopup, RouteParams, SpecialService, NotesModel, Logo, PrintNotesModel } from '../.././technician/technician-jobs/technician-jobs.models';
declare var $: any;

@Component({
    selector: 'print-all-notes',
    templateUrl: 'print-all-notes.component.html'
})

export class PrintAllNotesComponent extends BaseComponent implements OnInit {

    gi = new GlobalInfo;
    message = new FPMessage;
    rp = new RouteParams;

    @Input() roleSpecialInstruction = new RoleAccess;
    @Input() roleServiceNotes = new RoleAccess;
    @Input() roleAdminNotes = new RoleAccess;
    @Input() AllButtonDisable: boolean;
    @Input() isPageReadOnly: boolean = false;
    @Input() woCustomerId: number;
    @Input() TechTimeZoneid: number;
    @Input() woId: number;
    @Input() CustomerTimeZoneid: number;
    @Input() CustomerId: number;
    @Input() jobId:number;
    @Input() WoNumber:string;
    @Input() CustomerName:string;
    @Output() close = new EventEmitter();
    @Input() headername: boolean;
    //model initialize
    specialInstruction: SpecialService[] = [];
    serviceNotes: SpecialService[] = [];
    adminNotes: SpecialService[] = [];
    editNotes = new NotesModel;
    frmPrintAllNotes: FormGroup;
    logo: Logo = new Logo();
    //variable declare  
    headerName: string;
    eventName: string;
    displayName: string;
    selectedIns: number;
    selectedNotes: number;
    selectedAdminNotes: number;
    techRemarks: number;
    accordionNote: boolean;
    accordionRemark: boolean;
    editServiceNote: boolean;
    accordion: boolean;
    TechnicianTimeZoneid: number;

    UserLoginId: number;
    expanded1: boolean = false;
    expanded2: boolean = false;
    primaryKeyId: number;

    constructor(
        protected sharedService: SharedService,
        protected translate: TranslateService,
        private _technicianJobService: TechnicianJobService,
        private _fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private loaderservice: LoaderService,
        private datePipe: DatePipe,
        private confirmationService: ConfirmationService
    ) {

        super(sharedService, translate);
        this.gi = super.globalInfo();
        this.UserLoginId = this.globalInfo().LoginId;
    }

    ngOnInit() {
        this._technicianJobService.GetCompanyLogo(super.globalInfo().CompanyId, super.globalInfo().LogoPath).subscribe(res => {
            this.logo = res;
        });
        this.headerName=this.headername==true?this.translate.instant('NOTEPREVIEW'):this.translate.instant('PRINTPREVIEW');
        this.getRouteParams();
        this.GetNotesDetails();
        this.frmPrintAllNotes = this._fb.group({
            PrintSplInstruction: [true],
            PrintServiceNotes: [true],
            PrintAdminNotes: [true]
        });
    }

    getRouteParams(): void {
        this.route.params.subscribe(params => {
            this.rp.WoJobId = params['id'];
            this.rp.WorkOrderId = params['workOrderId'];
            this.rp.WoCategoryId = params['woCategoryId'];
            this.rp.TechnicianId = params['TechnicianId'];
            this.rp.WoNumber = params['WoNumber'];
        });
    }


    GetNotesDetails(): void {
        var i = 1;
        var j = 1;
        var k = 1;
        console.log("cust " + this.CustomerId + " & " + this.woCustomerId)
        this._technicianJobService.GetSpeciInstrAndServiNote(this.gi.CompanyId, this.jobId,
            this.gi.LoginId, this.CustomerTimeZoneid, this.CustomerId, this.woId)
            .subscribe(s => {

                this.displayName = s.DisplayName;
                this.specialInstruction = s.GetWojobSplInsDetails;
                this.serviceNotes = s.GetWojobServiceNotesDetails;
                this.adminNotes = s.AdminNotesDetails;
                this.specialInstruction.map(x=>{x.NoteHtml = x.Note.replace(/(?:\r\n|\r|\n)/g, '<br />')});
                this.serviceNotes.map(x=>{x.NoteHtml = x.Note.replace(/(?:\r\n|\r|\n)/g, '<br />')});
                this.adminNotes.map(x=>{x.NoteHtml = x.Note.replace(/(?:\r\n|\r|\n)/g, '<br />')});
                if (this.adminNotes != null && this.adminNotes.length != 0) {
                    this.adminNotes = this.adminNotes.map(m => {
                        if (m.LastUpdate === null && m.LastChangedBy === null) {
                            m.CreateAndUpdate = m.CreatedBy,
                                m.CreateAndUpdateDate = this.formatDateTime(m.CreatedDate)
                        } else {
                            m.CreateAndUpdate = m.LastChangedBy,
                                m.CreateAndUpdateDate = this.formatDateTime(m.LastUpdate)
                        }

                        return m;
                    });
                    this.adminNotes.map(v => v.tempId = 0);
                    this.adminNotes.forEach(element => {
                        element.tempId = i;
                        i = i + 1;
                    });
                }

                if (this.specialInstruction != null && this.specialInstruction.length != 0) {
                    this.specialInstruction = this.specialInstruction.map(m => {

                        if (m.LastUpdate === null && m.LastChangedBy === null) {
                            m.CreateAndUpdate = m.CreatedBy,
                                m.CreateAndUpdateDate = this.formatDateTime(m.CreatedDate)
                        } else {
                            m.CreateAndUpdate = m.LastChangedBy,
                                m.CreateAndUpdateDate = this.formatDateTime(m.LastUpdate)
                        }
                        return m;
                    });
                    this.specialInstruction.map(v => v.tempId = 0);
                    this.specialInstruction.forEach(element => {
                        element.tempId = j;
                        j = j + 1;
                    });
                }

                if (this.serviceNotes != null && this.serviceNotes.length != 0) {
                    this.serviceNotes = this.serviceNotes.map(m => {
                        if (m.LastUpdate === null && m.LastChangedBy === null) {
                            m.CreateAndUpdate = m.CreatedBy,
                                m.CreateAndUpdateDate = this.formatDateTime(m.CreatedDate)
                        } else {
                            m.CreateAndUpdate = m.LastChangedBy,
                                m.CreateAndUpdateDate = this.formatDateTime(m.LastUpdate)
                        }

                        return m;
                    });
                    this.serviceNotes.map(v => v.tempId = 0);
                    this.serviceNotes.forEach(element => {
                        element.tempId = i;
                        i = i + 1;
                    });
                }
            });
    }

    closePopup() {
        this.close.emit();
    }

    //Date and Time format  01/01/2017 09:00AM
    formatDateTime(data: Date): any {

        if (!ValidationService.isEmpty(data)) {
            let result = this.datePipe.transform(data, 'shortDate') + " " + this.datePipe.transform(data, 'shortTime');
            return result;
        }
    }

    exportToExcel() {
        var printNotes: PrintNotesModel[] = [];
        if (this.frmPrintAllNotes.controls["PrintSplInstruction"].value && this.roleSpecialInstruction.ViewRights == 1) {
            this.specialInstruction.forEach(x => {
                printNotes.push({
                    NotesType: this.translate.instant("SPECIALINSTRUCTIONS"),
                    UpdatedBy: x.LastChangedByName == null || x.LastChangedByName == '' ? x.CreatedByName : x.LastChangedByName,
                    UpdatedOn: x.CreateAndUpdateDate,
                    Notes: x.Note
                });
            });
        }
        if (this.frmPrintAllNotes.controls["PrintServiceNotes"].value && this.roleServiceNotes.ViewRights == 1) {
            this.serviceNotes.forEach(x => {
                var note: PrintNotesModel = new PrintNotesModel();
                note.NotesType = this.translate.instant("SERVICENOTES");
                note.UpdatedBy = x.LastChangedByName == null || x.LastChangedByName == '' ? x.CreatedByName : x.LastChangedByName;
                note.UpdatedOn = x.CreateAndUpdateDate;
                if (x.NotesMasterId == 52)
                    note.Notes = this.translate.instant("CANCELLATIONREMARKSFORJOB") + ' ' + x.PrimaryKeyId + '] ' + x.Note;
                else if (x.NotesMasterId == 53)
                    note.Notes = this.translate.instant("COMPLETEDREMARKSFORJOB") + ' ' + x.PrimaryKeyId + '] ' + x.Note;
                else if (x.NotesMasterId == 54)
                    note.Notes = this.translate.instant("UNRESOLVEDREMARKSFORJOB") + ' ' + x.PrimaryKeyId + '] ' + x.Note;
                else
                    note.Notes = x.Note;
                printNotes.push(note);
            });
        }
        if (this.frmPrintAllNotes.controls["PrintAdminNotes"].value && this.roleAdminNotes.ViewRights == 1) {
            this.adminNotes.forEach(x => {
                var note: PrintNotesModel = new PrintNotesModel();
                note.NotesType = this.translate.instant("ADMINNOTES");
                note.UpdatedBy = x.LastChangedByName == null || x.LastChangedByName == '' ? x.CreatedByName : x.LastChangedByName;
                note.UpdatedOn = x.CreateAndUpdateDate;
                if (x.NotesMasterId == 52)
                    note.Notes = this.translate.instant("CANCELLATIONREMARKSFORJOB") + ' ' + x.PrimaryKeyId + '] ' + x.Note;
                else if (x.NotesMasterId == 53)
                    note.Notes = this.translate.instant("COMPLETEDREMARKSFORJOB") + ' ' + x.PrimaryKeyId + '] ' + x.Note;
                else if (x.NotesMasterId == 54)
                    note.Notes = this.translate.instant("UNRESOLVEDREMARKSFORJOB") + ' ' + x.PrimaryKeyId + '] ' + x.Note;
                else
                    note.Notes = x.Note;
                printNotes.push(note);
            });
        }
        if (printNotes.length > 0) {
            let columns = 'NotesType as [' + this.translate.instant("NOTESTYPE") + '],UpdatedBy as [' + this.translate.instant("UPDATEDBY")
                + '],UpdatedOn as [' + this.translate.instant("UPDATEDON") + '],Notes as ' + this.translate.instant("NOTES") + '';

            this.sharedService.exportExcel('notes', 'notes.xlsx', columns, printNotes);
        }
        else {
            this.sharedService.notification.emit({
                severity: 'info',
                summary: this.translate.instant('INFOMESSAGE'),
                detail: this.translate.instant('NODATATOEXPORT')
            });
        }
    }
    printPdf() {
        let popupWinindow;
        let innerContents = document.getElementById('printSectionId').innerHTML;
        
        var element = $(innerContents);
        element.find('span[id^="printSplInstruction"]').remove();
        element.find('span[id^="printServiceNotes"]').remove();
        element.find('span[id^="printAdminNotes"]').remove();
        if (this.frmPrintAllNotes.controls["PrintSplInstruction"].value == false) {
            element.find('h1[id^="subHead1"]').remove();
            element.find('div[id^="role1"]').remove();
        }
        if (this.frmPrintAllNotes.controls["PrintServiceNotes"].value == false) {
            element.find('h1[id^="subHead2"]').remove();
            element.find('span[id^="role2"]').remove();
        }
        if (this.frmPrintAllNotes.controls["PrintAdminNotes"].value == false) {
            element.find('h1[id^="subHead3"]').remove();
            element.find('span[id^="role3"]').remove();
        }
        innerContents = element[0].innerHTML;
        popupWinindow = window.open('', '_blank', 'width=1000,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWinindow.document.open();
        var headerScript = `      
         <link rel="stylesheet" media="print" href="/assets/css/bootstrap/bootstrap.min.css">
         <link rel="stylesheet" media="print" href="/assets/css/zylog.css">
         
      `;
        popupWinindow.document.write('<html><head>' + headerScript + '</head><body>' + innerContents + '</html>');
        popupWinindow.document.close();
        popupWinindow.focus(); // necessary for IE >= 10*/ 

        setTimeout(function () { popupWinindow.print(); popupWinindow.close(); }, 3000);
    }

}

